module.exports = __webpack_public_path__ + "img/icon-diamante.9140ceac.svg";